import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-form", {
    ref: "form",
    attrs: {
      "label-width": "150px",
      "label-position": "right"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "渠道"
    }
  }, [_c("el-select", {
    style: {
      width: "100%"
    },
    attrs: {
      placeholder: "请选择下拉选择",
      filterable: "",
      clearable: ""
    },
    model: {
      value: _vm.test,
      callback: function callback($$v) {
        _vm.test = $$v;
      },
      expression: "test"
    }
  }, _vm._l(_vm.appList, function (item, index) {
    return _c("el-option", {
      key: index,
      attrs: {
        label: item.app_id + " (" + item.name + ")",
        value: item.app_id,
        disabled: item.disabled
      }
    });
  }), 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };